import { IAppState } from '../../redux';
import { EBetPositionErrorCode } from '../../redux/reducers';

export function selectBetPositionErrorCode(state: IAppState): EBetPositionErrorCode | null {
  const {
    betPosition: { errorCode },
  } = state;

  return errorCode;
}
